import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import type { SlotsStartLabelCalendarEvent } from '../../../types';

interface Props {
  event: SlotsStartLabelCalendarEvent;
}

export const SlotStartLabelEvent = ({ event }: Props) => {
  const { label } = event;
  return (
    <div css={containerStyle}>
      <Text size='small' color='subdued' textAlign='center' css={sideLines}>
        {label}
      </Text>
      <span css={compactLineStyle} aria-hidden='true' />
    </div>
  );
};

const containerStyle = css({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  containerType: 'inline-size',
  '@container (width < 120px)': {
    p: {
      '&::before, &::after': {
        display: 'none',
      },
    },
  },
  '@container (width < 90px)': {
    p: {
      display: 'none',
    },
    span: {
      display: 'block',
    },
  },
});

const sideLines = css({
  padding: theme.spacing(0.5, 0),
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::before, &::after': {
    margin: theme.spacing(0, 1),
    content: '" "',
    flex: 1,
    height: 1,
    background: theme.colors.neutral20,
  },
});
const compactLineStyle = css({
  margin: theme.spacing(1.5, 1),
  display: 'none',
  width: '100%',
  height: 1,
  background: theme.colors.neutral20,
});
